// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__p_wEh","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2T-PE"};